const prefix = {
  getFormImagePrefixPath: (apiEndpoint, clinicID, formID) => {
    // console.log("SDKV2", "getRecordImagePrefixPath");
    let clinic = clinicID ? clinicID : localStorage.getItem("CLINIC");
    return `${apiEndpoint}/api/photo/${clinic}/form/${formID}`;
  },
};

export default prefix;
